import styled from '@mui/material/styles/styled';
import Box from '../../Box';
var DrawerContent = styled(Box)(function (_a) {
    var _b = _a.isNullFooter, isNullFooter = _b === void 0 ? false : _b;
    return ({
        height: isNullFooter ? '100vh' : 'calc(100vh - 56px)',
        overflowY: 'auto',
        padding: '0 16px'
    });
});
export default DrawerContent;
